export default "__VITE_ASSET__DbowXtWL__"